import { Button } from "@growth/ui";
import { Newspaper } from "lucide-react";
import { Link } from "react-router-dom";

import { useActive } from "../lib/active";

/** Shown on blog pages when the active brand has no blog yet. */
export const NoBlog = () => {
  const { brand, atLeast } = useActive();
  return (
    <div className="mx-auto max-w-md space-y-4 rounded-xl border border-line bg-white p-8 text-center">
      <Newspaper className="mx-auto size-6 text-muted" />
      <h1 className="font-serif text-xl text-ink">{brand?.name ?? "This brand"} has no blog yet</h1>
      <p className="text-sm text-muted">
        {atLeast("OWNER")
          ? "Set up its address and look first, then posts can be written and published."
          : "Ask an owner of this workspace to set one up."}
      </p>
      {atLeast("OWNER") && (
        <Button asChild>
          <Link to="/blog-settings">Set up the blog</Link>
        </Button>
      )}
    </div>
  );
};
